
    import { defineComponent } from 'vue'
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import MobilityTypesService from '@/apps/shared/services/mobilityTypes-service';
    import ProductCardsSelector from '@/apps/shared/components/ProductCardsSelector.vue';
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    export default defineComponent({
        components: {
            XBreadcrumb,
            ProductCardsSelector
        },
        busEvents: {
            Next: function (data) {
                //prevenir que el evento Next y otras acciones de navegación se ejecuten de forma redundante.
                if (data.fromTab === 'tab-two') {
                    if (this.$refs.productCards && this.$refs.productCards.isNavigationAllowed) {  // Comprobamos si la navegación está permitida
                        this.$router.push({
                            name: 'movilidad-range-view',
                        });
                        this.$refs.productCards.isNavigationAllowed = false;  // Desactivamos la navegación
                    }
                }
            },
            SaveProductDataValueSession: function (value) {
                if (value.fromTab === 'tab-two') {
                    sessionStorage.removeItem('ProductDataSelected');
                    sessionStorage.setItem('ProductDataSelected', JSON.stringify(value));
                }
            },
        },

        data() {
            return {
                productCardsSelector: {
                    iconPromotion: null,
                    otherIconPromotion: null,
                    icon: null,
                    product: "",
                    title: "¿Qué necesitás cotizar?",
                    subTitle: "Elegí una opción para comenzar.",
                    tabName: "tab-two",
                } as TitleAndPromotionsDetails,
                breadcrumItems: [
                    { text: 'Inicio', path: '/movilidad' },
                    { text: 'Cotizador de Movilidad', path: '/movilidad/cotizarMovilidad' },
                ],
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Movilidad urbana';
                const actualPath = '/movilidad';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultUrbanMobilityGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
            getMobilityTypes: function () {
                var productId = 936;
                var securityGroup = '';
                let userName = '';
                let userToken = '';
                let tokenType = "";
                let correlationInformation = "";
                let onDate = new Date().toISOString();
                MobilityTypesService.getMobilityTypes(productId, securityGroup, onDate, correlationInformation, userName, userToken, tokenType)
                    .then(response => {
                        var vehicles = response.map(element => ({
                            ...element,
                            code: element["mobilityTypeId"],
                            productDescription: element["vehTypeDescription"],
                            hasProductNoteValue: element["notes"] == "" ? false : true,
                        }));
                        this.$refs.productCards.setProductData(vehicles);
                        NF.UI.Page.unblock();
                    })
            },

            volver() {
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'tabOne',
                })
            },
            getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");
                this.getMobilityTypes();
                this.validBack = sessionStorage.getItem("pressBack");
                if (this.validBack) {
                    // Permite la navegación nuevamente cuando el componente regresa a este tab
                    this.$refs.productCards.resetNavigationFlag();
                    var productData = JSON.parse(sessionStorage.getItem("ProductDataSelected"));
                    if (productData) {
                        //Llama a la funcion de productCardsSelector.vue, luego de que regresan la pantalla y muestra la opcion elegida
                        this.$refs.productCards.getDataProductBack(productData);
                    }
                    sessionStorage.removeItem("pressBack");
                }
            },
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                const parallelPromises = [
                    this.pageCustomization(),
                    this.updateByProductGoogleAnalytics(),
                    this.getInitData()
                ];

                this.referente = sessionStorage.getItem("Referente");

                await Promise.all([
                    ...parallelPromises,
                ]);

            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
